import React from 'react'
import sponsors from './sponsors.json'

function App() {
  return (
    <div
      id="home"
      className="antialiased min-h-screen flex justify-center items-start font-sans  text-white"
    >
      <style>{`#devtools-switcher { display: none; }`}</style>
      <div className="block mt-16 mb-16 text-lg px-5 sm:px-8 max-w-full md:max-w-screen-md">
        <h1 className="text-4xl sm:text-5xl md:text-6xl leading-none mt-40 mb-32 font-bold font-display">
          The missing
          <br />
          <span id="tagline" className="text-purple-500">
            browser devtools
            <br />
            for Tailwind CSS
          </span>
        </h1>

        <p className="flex items-center mb-32 space-x-8 font-bold">
          <a
            href="https://www.youtube.com/watch?v=5rnxb2XypPE"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-white hover:text-blue-200 group"
          >
            <span className="border-b-2 border-transparent group-hover:border-blue-600">
              Watch a demo
            </span>
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5401 6.42C22.4213 5.94541 22.1794 5.51057 21.8387 5.15941C21.4981 4.80824 21.0708 4.55318 20.6001 4.42C18.8801 4 12.0001 4 12.0001 4C12.0001 4 5.12008 4 3.40008 4.46C2.92933 4.59318 2.50206 4.84824 2.16143 5.19941C1.8208 5.55057 1.57887 5.98541 1.46008 6.46C1.1453 8.20556 0.991319 9.97631 1.00008 11.75C0.988863 13.537 1.14285 15.3213 1.46008 17.08C1.59104 17.5398 1.83839 17.9581 2.17823 18.2945C2.51806 18.6308 2.9389 18.8738 3.40008 19C5.12008 19.46 12.0001 19.46 12.0001 19.46C12.0001 19.46 18.8801 19.46 20.6001 19C21.0708 18.8668 21.4981 18.6118 21.8387 18.2606C22.1794 17.9094 22.4213 17.4746 22.5401 17C22.8524 15.2676 23.0064 13.5103 23.0001 11.75C23.0113 9.96295 22.8573 8.1787 22.5401 6.42V6.42Z"
                fill="#F4001C"
              />
              <path
                d="M9.75 15.0205L15.5 11.7505L9.75 8.48047V15.0205Z"
                fill="#FFF"
                stroke="#FFF"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <span className="text-gray-400">or</span>

          <a
            href="/demo"
            target="_blank"
            className="inline-flex items-center text-white hover:text-blue-200 group"
          >
            <span className="mr-2 border-b-2 border-transparent group-hover:border-blue-600">
              Try it yourself
            </span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.8824 15V5C22.8824 2.79086 21.0915 1 18.8823 1H5C2.79086 1 1 2.79087 1 5.00001V18.8824C1 21.0915 2.79086 22.8824 5 22.8824H14.5"
                stroke="#3dccff"
                strokeWidth="2"
              />
              <path
                d="M16.5294 16.5293L20.0584 24.9999L21.3113 21.3112L25 20.0583L16.5294 16.5293Z"
                fill="white"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.5209 21.521L25.5209 25.521"
                stroke="white"
                fill="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </p>

        <p className="flex items-center mb-32 space-x-8 font-bold">
          <a href="#intro-avatar" className="flex items-center space-x-2">
            <span>Read on</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg>
          </a>
        </p>

        <img
          id="intro-avatar"
          src="/siddharthkp.jpg"
          alt=""
          className="-ml-1 w-24 h-24 rounded-full mb-10 border-2 border-blue-500"
        />
        <p className="mb-10 space-x-2">
          Hi,{' '}
          <a
            href="https://twitter.com/siddharthkp"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-400 border-b-2 border-blue-600 hover:border-transparent"
          >
            I'm Sid.
          </a>
          <span>I'm a frontend developer.</span>
        </p>
        <p className="mb-10">
          I spend most of my coding time writing state logic and styling
          elements in VSCode — a code editor.
        </p>

        <p className="mb-10">
          I'm pretty happy with the way we represent UI logic with text. It's
          flexible and powerful at the same time.
        </p>
        <pre className="rounded-lg m-0 mb-16 pl-5 py-4 font-mono text-sm bg-cool-gray-800 whitespace-pre overflow-x-hidden">
          <span className="text-cool-gray-300">{`<`}</span>
          <span className="text-green-300">{`ul`}</span>
          <span className="text-cool-gray-300">{`>`}</span>
          <br />
          <span className="pl-4" />
          <span className="text-cool-gray-300">{`{`}</span>
          <span className="text-yellow-300">{`users`}</span>
          <br />
          <span className="pl-8" />
          <span className="text-cool-gray-300">{`.`}</span>
          <span className="text-green-300">{`filter`}</span>
          <span className="text-cool-gray-300">{`(`}</span>
          <span className="text-cool-gray-100">{`user `}</span>
          <span className="text-blue-300">{`=> `}</span>
          <span className="text-yellow-300">{`user`}</span>
          <span className="text-cool-gray-300">{`.`}</span>
          <span className="text-yellow-300">{`privacy`}</span>
          <span className="text-cool-gray-300">{` === `}</span>
          <span className="text-purple-400">{`'PUBLIC'`}</span>
          <span className="text-cool-gray-300">{`)`}</span>
          <br />
          <span className="pl-8" />
          <span className="text-cool-gray-300">{`.`}</span>
          <span className="text-green-300">{`map`}</span>
          <span className="text-cool-gray-300">{`(`}</span>
          <span className="text-cool-gray-100">{`user `}</span>
          <span className="text-blue-300">{`=> `}</span>
          <span className="text-cool-gray-300">{`<`}</span>
          <span className="text-green-300">{`li`}</span>
          <span className="text-cool-gray-300">{`>`}</span>
          <span className="text-cool-gray-300">{`{`}</span>
          <span className="text-yellow-300">{`user`}</span>
          <span className="text-cool-gray-300">{`.`}</span>
          <span className="text-yellow-300">{`name`}</span>
          <span className="text-cool-gray-300">{`}`}</span>
          <span className="text-cool-gray-300">{`</`}</span>
          <span className="text-green-300">{`li`}</span>
          <span className="text-cool-gray-300">{`>`}</span>
          <span className="text-cool-gray-300">{`)`}</span>
          <br />
          <span className="pl-4" />
          <span className="text-cool-gray-300">{`}`}</span>
          <br />
          <span className="text-cool-gray-300">{`</`}</span>
          <span className="text-green-300">{`ul`}</span>
          <span className="text-cool-gray-300">{`>`}</span>
        </pre>

        <section>
          <p className="mb-10">
            But, authoring styles in code feels a bit awkward.
          </p>
          <p className="mb-10">
            Styling is a visual task, to do it in text feels like you have the
            wrong tools.
          </p>
          <p className="mb-10">
            This friction is especially visible if you use a utility or tokens
            based framework like Tailwind CSS. You need to continously shift
            your focus between the code and preview in a hit and trial attempt
            to get to the right class.
          </p>

          <p className="mb-14">
            <img
              src="/color-trial.gif"
              className="rounded shadow mb-2"
              alt=""
            />
            <label className="text-sm block text-center italic text-purple-100">
              try and try again till you succeed to pick the perfect color.
            </label>
          </p>
          <p className="mb-10">
            I hope that your compile step is fast enough to at least give you
            feedback quickly. Wouldn't wish the frustrations of working with a
            slow feedback loop even on my enemies!
          </p>

          <p className="mb-10">
            Browser devtools were built to help us with this. But, when the
            abstraction level of the devtool (css / hex codes) doesn't match the
            abstraction at which you author code (tokens based utility classes),
            it stops being as useful.
          </p>
          <p className="mb-10">
            <img src="/copy-color.gif" className="rounded shadow mb-3" alt="" />
            <label className="text-sm block text-center italic text-purple-100">
              I miss copy paste
            </label>
          </p>
          <p className="mb-10">
            You can translate the raw css to the abstraction level you author in
            (
            <span className="font-mono text-base">
              #9061f9 → purple-500, 40px → 2.5rem
            </span>
            )
          </p>
          <p className="mb-10">OR</p>
          <p className="italic text-purple-400">
            You can upgrade your tooling to the abstraction level you author in.
          </p>
        </section>

        <p className="flex justify-center my-40 space-x-2">
          <span className="bg-purple-400 opacity-75 inline-block w-1 h-1 rounded-full"></span>
          <span className="bg-purple-400 opacity-75 inline-block w-1 h-1 rounded-full"></span>
        </p>

        <section className="mb-15">
          <h2 id="tooling" className="mb-16 font-bold text-4xl">
            Better tooling
          </h2>
          <p className="mb-15">
            <span className="text-purple-400">UI Devtools</span> is an attempt
            at better tooling for developers. This is what the above task looks
            like with the right tool:
          </p>
          <p className="mb-15">
            <img
              src="/instant-color.gif"
              className="rounded shadow mb-2"
              alt=""
            />
            <label className="text-sm block text-center italic text-purple-100">
              Make visual choices visually with instant feedback before making a
              decision.
            </label>
          </p>

          <p className="mb-15">
            Colors are picked from your tailwind config.
            <br />
            <br />
            So are the space units:
          </p>
          <p>
            <img src="/margin2.gif" className="rounded shadow mb-3" alt="" />
            <label className="text-sm block text-center italic text-purple-100">
              The right medium with the right options
            </label>
          </p>
        </section>

        <section className="my-48 text-center">
          <p className="italic text-2xl text-purple-400">
            It's not a design tool. <br />
            <br />
            It's a developer tool, for design tasks.
          </p>
        </section>

        <section className="mb-48">
          <h2 className="mb-16 font-bold text-4xl">
            Save changes{' '}
            <span className="text-purple-500">back to source.</span>
          </h2>

          <p className="mb-6">
            All changes you make "visually" are made back to the source with the
            correct Tailwind CSS classes based on your config - exactly like you
            would.
          </p>
          <p className="mb-8">This is a big productivity boost!</p>

          <p>
            <img src="/code-sync.gif" className="rounded shadow mb-3" alt="" />
            <label className="italic block font-sans text-sm text-center text-purple-100">
              Changes are committed back to code.
            </label>
          </p>
        </section>

        <section className="mb-20">
          <h2 className="mb-16 font-bold text-4xl">How does it work?</h2>
          <p className="mb-8">Three steps:</p>
          <div className="flex mb-8 items-start">
            <span className="w-8 h-8 text-green-400 border-2 border-green-400 leading-8 flex-shrink-0 mr-5 inline-flex justify-center items-center text-sm rounded-full font-bold">
              0
            </span>
            <p>
              Install the private package as a dev dependency (
              <a
                href="#get-it"
                className="hover:text-blue-400 border-b-2 border-blue-600 hover:border-transparent"
              >
                see below
              </a>
              )
            </p>
          </div>
          <div className="flex mb-6 items-start">
            <span className="w-8 h-8 text-blue-400 border-2 border-blue-400 leading-8 flex-shrink-0 mr-5 inline-flex justify-center items-center text-sm rounded-full font-bold">
              1
            </span>
            <p>
              <span className="rounded py-1 pl-2 pr-1 mr-1 font-mono leading-snug text-sm bg-cool-gray-800 text-purple-400">
                import {'{ Devtools }'} from '@ui-devtools/tailwind'
              </span>{' '}
              and wrap your application root with{' '}
              <span className="rounded py-1 pl-2 pr-1 mr-1 font-mono leading-snug text-sm bg-cool-gray-800 text-purple-400">
                {'<Devtools>'}
              </span>
            </p>
          </div>

          <div className="flex mb-16 items-start">
            <span className="w-8 h-8 text-purple-400 border-2 border-purple-400 leading-8 flex-shrink-0 mr-5 inline-flex justify-center items-center text-sm rounded-full font-bold">
              2
            </span>
            <p>
              <span className="rounded py-1 px-2 mr-1 font-mono leading-snug text-sm bg-cool-gray-800 text-purple-400">
                npx devtools-server -c tailwind.config.js
              </span>{' '}
              in the terminal to run the server that syncs changes back to
              source (for React projects)
            </p>
          </div>

          <h2 className="mb-10 font-bold">See it in action:</h2>
          <p className="flex flex-row items-center text-left mb-12 space-x-4">
            <a
              href="https://www.youtube.com/watch?v=5rnxb2XypPE"
              target="_blank"
              rel="noopener noreferrer"
              className="pl-5 pr-6 h-12 shadow-sm focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out inline-flex rounded-md font-medium text-base bg-white text-gray-900 hover:text-red-700 focus:text-red-700  items-center"
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5401 6.42C22.4213 5.94541 22.1794 5.51057 21.8387 5.15941C21.4981 4.80824 21.0708 4.55318 20.6001 4.42C18.8801 4 12.0001 4 12.0001 4C12.0001 4 5.12008 4 3.40008 4.46C2.92933 4.59318 2.50206 4.84824 2.16143 5.19941C1.8208 5.55057 1.57887 5.98541 1.46008 6.46C1.1453 8.20556 0.991319 9.97631 1.00008 11.75C0.988863 13.537 1.14285 15.3213 1.46008 17.08C1.59104 17.5398 1.83839 17.9581 2.17823 18.2945C2.51806 18.6308 2.9389 18.8738 3.40008 19C5.12008 19.46 12.0001 19.46 12.0001 19.46C12.0001 19.46 18.8801 19.46 20.6001 19C21.0708 18.8668 21.4981 18.6118 21.8387 18.2606C22.1794 17.9094 22.4213 17.4746 22.5401 17C22.8524 15.2676 23.0064 13.5103 23.0001 11.75C23.0113 9.96295 22.8573 8.1787 22.5401 6.42V6.42Z"
                  fill="#F4001C"
                />
                <path
                  d="M9.75 15.0205L15.5 11.7505L9.75 8.48047V15.0205Z"
                  fill="#FFF"
                  stroke="#FFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="ml-2">Watch a demo</span>
            </a>
            <a
              href="/demo"
              target="_blank"
              className="px-6 h-12 shadow-sm focus:outline-none focus:shadow-outline-blue transition duration-150 ease-in-out inline-flex rounded-md text-white font-medium text-base bg-blue-700 hover:bg-blue-600 focus:bg-blue-600 items-center"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.8824 15V5C22.8824 2.79086 21.0915 1 18.8823 1H5C2.79086 1 1 2.79087 1 5.00001V18.8824C1 21.0915 2.79086 22.8824 5 22.8824H14.5"
                  stroke="#3dccff"
                  strokeWidth="2"
                />
                <path
                  d="M16.5294 16.5293L20.0584 24.9999L21.3113 21.3112L25 20.0583L16.5294 16.5293Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21.5209 21.521L25.5209 25.521"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="ml-2">Try it yourself</span>
            </a>
          </p>
          <p>
            <span className="flex gap-3 items-start mb-6 sm:items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-green-500 flex-shrink-0 mt-1 sm:mt-0"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <span>
                The visual editor works with any project that uses Tailwind.
              </span>
            </span>
            <span className="flex gap-3 items-start mb-6 md:items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-yellow-400 flex-shrink-0 mt-1 md:mt-0"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              Syncing changes back to source code only works with React projects
              today.
            </span>
          </p>
        </section>

        <section className="mb-48">
          <h2 id="get-it" className="mb-16 font-bold text-4xl">
            Get access
          </h2>
          <p className="mb-6">
            UI Devtools for Tailwind CSS is maintained as <i>sponsorware.</i>
          </p>
          <p>To ensure this project:</p>
          <ul className="dashed mt-4 mb-10 space-y-4">
            <li>
              stays updated with breaking and non-breaking releases of
              TailwindCSS
            </li>
            <li>keeps improving as a visual tool</li>
            <li>adds support for other stacks like Vue and good old HTML</li>
            <li>doesn't fade away over time</li>
            <li>is run as a sustainable open source project</li>
          </ul>
          <p className="mb-6">
            It is available only to GitHub Sponsors till it reaches the
            sustainability goal of 100 sponsors. After that, it will be open
            source.
          </p>
          <p className="mb-10">
            As a GitHub sponsor, you get access to the private package and code
            repository today, several months before everyone else, and help
            shape the project with your feedback.
          </p>
          <a
            id="github-sponsors"
            href="https://github.com/sponsors/siddharthkp"
            target="_blank"
            rel="noopener noreferrer"
            className="pl-5 pr-6 py-3 mb-6 space-x-2 shadow-sm focus:outline-none focus:shadow-outline-blue inline-flex rounded-md text-white font-medium text-base bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 focus:to-blue-700 items-center transition transition-150 ease-out group"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.49936 0.850006C3.82767 0.850006 0.849976 3.8273 0.849976 7.50023C0.849976 10.4379 2.75523 12.9306 5.39775 13.8104C5.73047 13.8712 5.85171 13.6658 5.85171 13.4895C5.85171 13.3315 5.846 12.9135 5.84273 12.3587C3.99301 12.7604 3.60273 11.4671 3.60273 11.4671C3.30022 10.6988 2.86423 10.4942 2.86423 10.4942C2.26044 10.0819 2.90995 10.0901 2.90995 10.0901C3.57742 10.137 3.9285 10.7755 3.9285 10.7755C4.52167 11.7916 5.48512 11.4981 5.86396 11.3279C5.92438 10.8984 6.09625 10.6053 6.28608 10.4391C4.80948 10.2709 3.25695 9.70063 3.25695 7.15241C3.25695 6.42615 3.51618 5.83298 3.94157 5.368C3.87299 5.1998 3.64478 4.52375 4.00689 3.60807C4.00689 3.60807 4.56494 3.42926 5.83538 4.28941C6.36568 4.14204 6.93477 4.06856 7.50018 4.0657C8.06518 4.06856 8.63386 4.14204 9.16498 4.28941C10.4346 3.42926 10.9918 3.60807 10.9918 3.60807C11.3548 4.52375 11.1266 5.1998 11.0584 5.368C11.4846 5.83298 11.7418 6.42615 11.7418 7.15241C11.7418 9.70716 10.1868 10.2693 8.70571 10.4338C8.94412 10.6392 9.15681 11.045 9.15681 11.6655C9.15681 12.5542 9.14865 13.2715 9.14865 13.4895C9.14865 13.6675 9.26867 13.8745 9.60588 13.8095C12.2464 12.9282 14.15 10.4375 14.15 7.50023C14.15 3.8273 11.1723 0.850006 7.49936 0.850006Z"
                fill="currentColor"
              />
              <path
                d="M13.4304 9.53728C13.2602 9.36694 13.058 9.23182 12.8355 9.13964C12.6131 9.04745 12.3746 9 12.1338 9C11.8929 9 11.6545 9.04745 11.432 9.13964C11.2095 9.23182 11.0073 9.36694 10.8371 9.53728L10.4838 9.89061L10.1304 9.53728C9.78653 9.19338 9.32011 9.00018 8.83376 9.00018C8.34742 9.00018 7.88099 9.19338 7.5371 9.53728C7.1932 9.88117 7 10.3476 7 10.8339C7 11.3203 7.1932 11.7867 7.5371 12.1306L7.89043 12.4839L10.4838 15.0773L13.0771 12.4839L13.4304 12.1306C13.6008 11.9604 13.7359 11.7582 13.8281 11.5357C13.9203 11.3132 13.9677 11.0748 13.9677 10.8339C13.9677 10.5931 13.9203 10.3546 13.8281 10.1322C13.7359 9.90967 13.6008 9.70753 13.4304 9.53728V9.53728Z"
                fill="#EC6CB9"
                stroke="#A72573"
                className="opacity-0 group-hover:opacity-100 transition-opacity duration-150"
              />
            </svg>

            <span>Sponsor on GitHub to get access</span>
          </a>
          <p className="mb-8 text-base">
            <a
              href="https://twitter.com/siddharthkp/status/1324402646762086407"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-400 border-b-2 border-blue-600 hover:border-transparent"
            >
              Read more behind the decision
            </a>
          </p>
          <p></p>
        </section>

        <section className="mb-48">
          <div className="mb-8 space-y-2">
            <span className="text-sm">
              {sponsors.length}% towards 100 sponsors goal
            </span>
            <div className="relative w-80 h-2 bg-gray-800 rounded">
              <div
                className="absolute h-2 bg-pink-500 rounded sponsors-progress"
                style={{ width: sponsors.length * 0.2 + 'rem' }}
              ></div>
            </div>
          </div>

          <p className="text-sm mb-4">
            Thank you to the folks who sponsor my work:
          </p>
          <p className="flex items-center mb-4 max-w-lg">
            <a
              className="flex items-center mr-8"
              href="https://egghead.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 33 34"
                className="w-8 mr-1"
              >
                <g fill="none">
                  <path
                    fill="#FFF"
                    d="M16.556,33.9840112 C9.666,33.993 3.984,28.592 3.641,21.711 L3.641,21.686 C2.38330604,21.5276246 1.35108978,20.6148613 1.04,19.386 C0.679,17.972 0.19,15.86 0.132,13.83 C0.0943730103,12.6557373 0.771608539,11.5756395 1.845,11.098 C2.899,10.625 4.402,10.238 6.297,9.945 C7.357,7.495 8.608,5.365 9.931,3.76 C11.992,1.265 14.221,0 16.556,0 C18.891,0 21.118,1.265 23.176,3.761 C24.493,5.366 25.749,7.493 26.807,9.938 C28.689,10.222 30.19,10.611 31.273,11.093 C32.3458049,11.568777 33.0234964,12.6469944 32.987,13.82 C32.929,15.861 32.441,17.974 32.08,19.385 C31.7694332,20.6162666 30.7350536,21.5307296 29.475,21.688 L29.475,21.711 C29.1224003,28.5910063 23.4390344,33.9872358 16.55,33.983 L16.555,33.9840112 L16.556,33.9840112 Z"
                  ></path>
                  <path
                    fill="#FCFBFA"
                    d="M16.548,2.15 C22.531,2.15 27.382,15.01 27.382,20.994 C27.382,26.978 22.532,31.829 16.547,31.829 C10.564,31.829 5.713,26.979 5.713,20.994 C5.714,15.01 10.565,2.15 16.548,2.15 Z"
                  ></path>
                  <path
                    fill="#252526"
                    d="M30.286,12.529 L25.866,14.088 C25.866,14.088 26.55,16.168 26.556,16.183 C26.563,16.199 30.96,15.616 30.96,15.616 L30.286,12.529 Z M2.81,12.529 L7.23,14.088 C7.23,14.088 6.547,16.168 6.54,16.183 C6.534,16.199 2.138,15.616 2.138,15.616 L2.811,12.529 L2.81,12.529 Z"
                  ></path>
                  <path
                    fill="#E0E0E0"
                    d="M12,12.16 C12.6891044,12.1438469 13.2841428,12.6393563 13.393,13.32 C13.533,14.072 13.626,14.833 13.67,15.598 C13.674206,15.8121531 13.6547548,16.026116 13.612,16.236 C13.5608848,15.7224979 13.4881536,15.2113778 13.394,14.704 C13.2851428,14.0233563 12.6901044,13.5278469 12.001,13.544 C10.341,13.561 8.681,13.687 7.037,13.922 C7.193,13.438 7.36,12.952 7.539,12.472 C9.0184704,12.2793603 10.5081178,12.1751751 12,12.16 L12,12.16 Z M27.362,20.513 C23.46,20.312 20.127,19.063 19.375,18.617 C18.788,18.337 18.04,17.742 17.825,16.255 C17.681,17.893 17.99,19.385 19.528,20.122 C19.641,20.19 22.585,21.647 27.336,21.897 C27.3743575,21.4367026 27.3830422,20.9744133 27.362,20.513 L27.362,20.513 Z M5.746,20.513 C9.648,20.312 12.981,19.063 13.733,18.617 C14.32,18.337 15.068,17.742 15.283,16.255 C15.427,17.893 15.118,19.385 13.58,20.122 C13.467,20.19 10.523,21.647 5.772,21.897 C5.73364246,21.4367026 5.72495783,20.9744133 5.746,20.513 Z M21.085,12.16 C20.3958956,12.1438469 19.8008572,12.6393563 19.692,13.32 C19.552,14.072 19.46,14.833 19.416,15.598 C19.411294,15.8121706 19.4307502,16.026189 19.474,16.236 C19.529,15.685 19.605,15.16 19.691,14.704 C19.800666,14.023817 20.3952023,13.5287257 21.084,13.544 C22.745,13.561 24.404,13.687 26.048,13.922 C25.8916915,13.4349199 25.7243148,12.9514614 25.546,12.472 C24.0668607,12.2794 22.5775483,12.1752149 21.086,12.16 L21.085,12.16 Z"
                  ></path>
                  <path
                    fill="#56555C"
                    d="M7.071,10.988 C8.135,8.408 9.411,6.175 10.761,4.531 C12.6,2.301 14.546,1.171 16.545,1.171 C18.545,1.171 20.491,2.301 22.329,4.529 C23.684,6.171 24.965,8.404 26.019,10.987 L26.071,11.119 L25.939,11.1 C25.563,11.05 25.258,11.014 24.885,10.968 L24.838,10.968 L24.82,10.926 C23.623,8.132 21.58,4.483 18.941,2.959 C18.2180927,2.51884066 17.3912212,2.2786476 16.545,2.263 C15.6991196,2.27882404 14.8726156,2.51901057 14.15,2.959 C11.517,4.481 9.48,8.113 8.273,10.922 L8.255,10.964 L8.209,10.964 C7.833,11.004 7.527,11.041 7.154,11.096 L7.023,11.115 L7.071,10.988 L7.071,10.988 Z M27.486,19.164 C27.192,19.156 26.896,19.144 26.604,19.127 L26.514,19.127 L26.502,19.036 C26.238,16.982 25.648,14.576 24.828,12.265 L24.775,12.092 L24.953,12.116 C25.288,12.161 25.612,12.211 25.928,12.264 L25.993,12.274 L26.014,12.336 C26.804,14.644 27.364,17.025 27.604,19.041 L27.619,19.173 L27.486,19.163 L27.486,19.164 Z"
                  ></path>
                  <path
                    fill="#252526"
                    d="M26.52,13.96 C26.360779,13.4156783 26.1897385,12.8748837 26.007,12.338 L25.987,12.276 L25.922,12.265 C25.611,12.212 25.282,12.162 24.947,12.117 L24.775,12.092 L24.835,12.262 C25.016,12.774 25.186,13.29 25.345,13.808 C25.907,13.873 26.225,13.918 26.52,13.96 L26.52,13.96 Z"
                  ></path>
                  <path
                    fill="#56555C"
                    d="M5.572,18.995 C5.812,16.979 6.377,14.598 7.162,12.29 L7.183,12.228 L7.248,12.216 C7.559,12.164 7.888,12.113 8.223,12.069 L8.401,12.045 L8.341,12.214 C7.523,14.525 6.929,16.929 6.668,18.984 L6.656,19.076 L6.566,19.076 C6.273,19.093 5.976,19.105 5.684,19.112 L5.552,19.112 L5.572,18.995 L5.572,18.995 Z"
                  ></path>
                  <path
                    fill="#252526"
                    d="M7.248,12.216 L7.183,12.226 L7.163,12.289 C6.98025357,12.8268881 6.80921322,13.3686826 6.65,13.914 C7.2,13.844 7.359,13.852 7.819,13.803 C7.981,13.276 8.155,12.739 8.346,12.213 L8.406,12.045 L8.227,12.069 C7.89999558,12.1134214 7.57363016,12.1624262 7.248,12.216 L7.248,12.216 Z"
                  ></path>
                  <path
                    fill="#56555C"
                    d="M16.548,32.802 C11.6950457,32.802368 7.33549873,29.8349252 5.556,25.32 C4.95803562,23.7900989 4.68162524,22.1534226 4.744,20.512 L4.744,20.438 L4.818,20.438 C5.203,20.428 5.466,20.418 5.74,20.404 L5.826,20.404 L5.826,20.489 C5.61387559,24.9551461 8.19420614,29.0844695 12.3013673,30.8515816 C16.4085284,32.6186937 21.1810255,31.6529351 24.278,28.428 C25.2593494,27.4101114 26.0276881,26.2066075 26.538,24.888 C27.082,23.488 27.325,21.99 27.254,20.491 L27.254,20.405 L27.34,20.405 C27.723,20.425 27.987,20.433 28.262,20.439 L28.336,20.439 L28.336,20.513 C28.4039497,22.1520989 28.1340233,23.7876557 27.543,25.318 C25.7675295,29.8366926 21.405984,32.8070829 16.551,32.8040024 L16.548,32.8040024 L16.548,32.802 Z"
                  ></path>
                  <path
                    fill="#252526"
                    d="M5.863,21.898 C5.825,21.428 5.815,20.955 5.834,20.483 L5.834,20.397 L5.748,20.397 C5.472,20.412 5.208,20.422 4.826,20.432 L4.752,20.432 L4.752,20.505 C4.736,20.979 4.746,21.453 4.784,21.925 L4.819,21.925 C5.175,21.925 5.523,21.909 5.854,21.893 L5.863,21.898 L5.863,21.898 Z M28.345,20.437 L28.271,20.437 C27.992,20.437 27.728,20.422 27.349,20.403 L27.263,20.403 L27.263,20.488 C27.283,20.956 27.273,21.424 27.236,21.89 L28.316,21.937 C28.354,21.464 28.364,20.991 28.348,20.517 L28.345,20.437 L28.345,20.437 Z"
                  ></path>
                  <path
                    fill="#252526"
                    d="M28.954,20.678 C26.6952475,20.6864276 24.445226,20.3972736 22.262,19.818 C21.322,19.571 20.407,19.238 19.528,18.827 L19.507,18.811 C17.662,17.929 17.594,16.161 17.766,14.549 C17.809,14.142 17.66,13.603 17.231,13.317 C16.8217025,13.0439161 16.2882975,13.0439161 15.879,13.317 C15.449,13.601 15.3,14.139 15.343,14.545 C15.515,16.158 15.443,17.926 13.603,18.808 L13.582,18.818 C12.7024943,19.2342431 11.7870861,19.5699486 10.847,19.821 C8.66377172,20.4002622 6.41375178,20.689416 4.155,20.681 L4.145,20.681 C3.20778056,20.6696199 2.39589547,20.0281608 2.168,19.119 C1.818,17.766 1.351,15.739 1.297,13.837 C1.27273427,13.0757044 1.7114252,12.3753797 2.407,12.065 C4.947,10.938 10.089,10.514 12.282,10.543 C13.047,10.537 13.782,10.841 14.32,11.385 C15.0216745,11.0561128 15.785163,10.8798969 16.56,10.868 C17.3346989,10.8792095 18.0981933,11.054745 18.8,11.383 C19.3336751,10.84257 20.0624847,10.5398004 20.822,10.543 C22.14,10.523 27.806,10.768 30.705,12.058 C31.3996549,12.3656831 31.838584,13.0636199 31.815,13.823 C31.761,15.728 31.288,17.766 30.949,19.116 C30.7211045,20.0251608 29.9092194,20.6666199 28.972,20.678 L28.954,20.678 L28.954,20.678 Z M21.098,12.244 C20.4473812,12.2295607 19.8855629,12.6966761 19.781,13.339 C19.641,14.089 19.549,14.846 19.504,15.607 C19.494,16.477 19.806,17.072 20.426,17.377 C22.75,18.413 25.45,18.925 28.681,18.941 C28.9286853,18.9397268 29.1447252,18.7724701 29.208,18.533 C29.515,17.333 29.929,15.548 29.977,13.907 C29.9821038,13.74977 29.891037,13.6052509 29.747,13.542 C27.543,12.551 22.82,12.212 21.098,12.239 L21.098,12.244 L21.098,12.244 Z M3.348,13.539 C3.20435474,13.6025589 3.11372656,13.7470099 3.119,13.904 C3.167,15.541 3.581,17.331 3.888,18.53 C3.95,18.77 4.167,18.938 4.415,18.939 C7.649,18.923 10.345,18.411 12.676,17.373 C13.298,17.07 13.609,16.473 13.599,15.6 C13.5541546,14.8398962 13.4613028,14.0833876 13.321,13.335 C13.2163861,12.692292 12.6539949,12.2250549 12.003,12.24 C11,12.224 5.845,12.427 3.349,13.54 L3.348,13.539 Z"
                  ></path>
                </g>
              </svg>
              <span className="hidden sm:inline-block text-lg font-semibold dark:text-gray-200">
                egghead.io
              </span>
            </a>
            {/* <a
              href="https://dovetailstudios.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg width="130" height="27" viewBox="0 0 130 27" fill="none">
                <path
                  d="M123.385 17.8982V6.71146H120.918V20.1527H130V17.8982H123.385Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M116.914 6.71146H114.449V20.1527H116.914V6.71146Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M104.288 6.71451L98.5312 20.1557H101.161L102.273 17.4507H108.038L109.131 20.1557H111.78L106.069 6.71451H104.288ZM107.138 15.2298H103.155L105.153 10.4108L107.138 15.2298Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M87.4453 6.71146V8.98425H91.7465V20.1527H94.2301V8.98425H98.5313V6.71146H87.4453Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M78.084 14.486H83.9156V12.2147H78.084V12.2132V8.98425V8.98272H84.7786V6.71146H75.6172V20.1527H84.7542V17.8982H78.084V14.486Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M67.2161 14.6067L66.6158 16.3525L65.9835 14.5761L62.8844 6.71146H60.1289L65.7131 20.1527H67.3643L72.9485 6.71146H70.2633L67.2161 14.6067Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M51.8337 6.54802C47.8426 6.54802 44.832 9.5112 44.832 13.4412C44.832 17.3713 47.8426 20.3146 51.8337 20.3146C53.775 20.3146 55.5468 19.6166 56.8237 18.3503C58.1007 17.0841 58.7987 15.3444 58.7987 13.4382C58.7987 9.5112 55.8034 6.54802 51.8337 6.54802ZM56.2953 13.4351C56.2953 16.0714 54.4196 17.9838 51.8337 17.9838C49.2478 17.9838 47.3339 16.0714 47.3339 13.4351C47.3339 10.8385 49.2692 8.86815 51.8337 8.86815C54.3982 8.86815 56.2953 10.8385 56.2953 13.4351Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M35.1729 6.71451H30.25V11.9703L31.2596 13.4428L30.25 14.9167V20.1557H35.1729C39.361 20.1557 42.1745 17.4507 42.1745 13.426C42.1745 9.40122 39.361 6.71451 35.1729 6.71451ZM32.7152 11.9352V8.9873H35.1591C37.9084 8.9873 39.6772 10.7362 39.6772 13.4443C39.6772 16.1524 37.9039 17.883 35.1591 17.883H32.7152V11.9352Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M12.8994 26.8764H1.62553C0.727413 26.8764 0.000364561 26.1493 0.000364561 25.2512C0.000364561 24.9228 0.0996465 24.6005 0.285991 24.3302L7.77031 13.4382L0.285991 2.54771C-0.222638 1.80692 -0.0347658 0.794254 0.706029 0.285626C0.976382 0.0992811 1.29714 0 1.62553 0H12.8994C14.6253 0 16.2398 0.847712 17.2189 2.26973L24.9171 13.4351L17.2219 24.6066C16.2429 26.0286 14.6253 26.8779 12.8994 26.8764ZM2.58627 24.738H12.8994C13.9227 24.738 14.8819 24.2339 15.4624 23.3908L22.3235 13.4321L15.4624 3.47334C14.8804 2.63173 13.9227 2.13074 12.8994 2.13226H2.5878L9.06556 11.5564L11.4773 8.04334C12.1189 7.11009 13.3942 6.87335 14.3275 7.51486C14.8835 7.89672 15.2165 8.52908 15.2165 9.20419V17.6645C15.2165 18.7963 14.2985 19.7143 13.1667 19.7143C12.4915 19.7143 11.8592 19.3813 11.4773 18.8254L9.06556 15.3123L2.58627 24.738ZM10.3562 13.4351L13.0796 17.3972V9.47453L10.3562 13.4351Z"
                  fill="currentColor"
                ></path>
              </svg>
            </a> */}

            {/* <a
              href="https://www.chromaticqa.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                width="214"
                height="28"
                viewBox="0 0 429 84"
              >
                <path
                  fill="#fff"
                  id="logotype-characters"
                  d="M328.514 28.754c8.295 0 14.537 4.567 14.537 14.51v19.881h-8.294l.244-4.809c-2.467 3.607-5.75 5.53-10.842 5.53-6.817 0-12.406-3.125-12.406-10.661 0-6.979 5.752-10.02 13.556-10.102h9.448c0-5.373-2.465-7.617-6.899-7.617-3.57 0-5.947 1.205-7.725 2.737l-5.992-3.376-.084-.083c.053-.06.104-.123.156-.178 3.023-3.429 7.11-5.832 14.301-5.832zm6.243 22.603v-2.645h-8.872c-3.615 0-5.998 1.284-5.998 4.253 0 2.884 2.301 4.405 6.572 4.405 4.848.001 8.298-2.325 8.298-6.013zm87.602 1.429L429 56.529c-3.266 4.436-8.587 7.337-14.611 7.337-9.935 0-17.985-7.862-17.985-17.558 0-9.694 8.05-17.555 17.985-17.555 6.016 0 11.32 2.889 14.59 7.309l-6.642 3.745a10.47 10.47 0 0 0-7.948-3.625c-5.72 0-10.374 4.542-10.374 10.125 0 5.582 4.654 10.127 10.374 10.127a10.453 10.453 0 0 0 7.97-3.648zm-291.403 0l6.641 3.743c-3.266 4.436-8.587 7.337-14.611 7.337-9.935 0-17.986-7.862-17.986-17.558 0-9.694 8.05-17.555 17.986-17.555 6.015 0 11.32 2.889 14.59 7.309l-6.642 3.745a10.47 10.47 0 0 0-7.948-3.625c-5.72 0-10.374 4.542-10.374 10.125 0 5.582 4.654 10.127 10.374 10.127a10.451 10.451 0 0 0 7.97-3.648zm121.446-23.31h8.296l-.164 5.772c2.302-4.248 5.833-6.494 10.27-6.494 5.009 0 8.298 2.322 10.104 6.412 2.71-4.007 6.817-6.412 11.827-6.412 8.131 0 12.976 5.292 12.976 13.867v20.523h-8.293v-19.72c0-4.651-1.728-7.216-6.491-7.216-4.842 0-7.721 2.887-7.721 8.5v18.437h-8.293V43.424c0-4.651-1.646-7.216-6.41-7.216-4.93 0-7.804 2.887-7.804 8.5v18.437h-8.296V29.476zM143.595 10h8.294v25.407c2.22-4.167 6.328-6.653 11.506-6.653 7.634 0 12.894 5.292 12.894 14.432v19.959h-8.3V43.826c0-4.811-2.297-7.618-7.147-7.618-5.42 0-8.953 3.208-8.953 8.66v18.276h-8.294V10zm84.235 18.754c9.939 0 17.988 7.86 17.988 17.555s-8.049 17.558-17.988 17.558c-9.932 0-17.986-7.862-17.986-17.558 0-9.695 8.054-17.555 17.986-17.555zm0 7.43c-5.717 0-10.373 4.541-10.373 10.125 0 5.582 4.656 10.127 10.373 10.127 5.727 0 10.381-4.545 10.381-10.127 0-5.584-4.654-10.126-10.381-10.125zm-43.295-6.708h8.3l-.085 6.331c2.305-5.29 6.245-6.974 10.024-6.974 1.768 0 3.16.29 4.345.78.467.19 1.443.648 2.393 1.342 0 0-1.15 1.396-2.161 3.094-1.016 1.7-1.702 3.522-1.702 3.522-1.314-.64-2.63-1.124-4.517-1.124-4.929 0-8.297 2.806-8.297 10.344v16.354h-8.3V29.476zm196.257 33.719V29.476h8.392v33.719h-8.392zm-1.315-46.804c0-3.05 2.549-5.3 5.51-5.3 2.963 0 5.514 2.25 5.514 5.3 0 3.21-2.551 5.378-5.514 5.378-2.962 0-5.51-2.167-5.51-5.378zm-24.734 35.406V36.3h-5.183v-6.824h5.183V10h8.309v19.477h9.214V36.3h-9.214v15.655c0 3.855 1.317 4.98 3.455 4.98 1.976 0 3.209-.885 4.113-1.607l3.95 5.459c-1.73 1.607-4.444 3.213-8.887 3.213-6.497 0-10.941-3.212-10.94-12.203z"
                ></path>
                <circle fill="#FC521F" cx="42" cy="42" r="42"></circle>
                <path
                  fill="#FFF"
                  d="M51.87 61.316l-6.674-3.852 20.078-11.581c.77-.444 1.495-.954 2.17-1.522 2.61 3.716 2.866 8.609.54 12.639a11.846 11.846 0 0 1-10.23 5.895c-2.057 0-4.09-.545-5.884-1.58v.001zm-1.608 2.782c.77.445 1.574.819 2.405 1.12C50.75 69.332 46.638 72 41.98 72c-6.502 0-11.795-5.287-11.795-11.785V37.051l10.187 5.879v14.535c0 .574.307 1.104.804 1.391l9.086 5.242zm-24.025-1.205a11.84 11.84 0 0 1-10.225-5.891 11.699 11.699 0 0 1-1.176-8.943 11.706 11.706 0 0 1 5.495-7.158l6.672-3.85.001 23.16c0 .889.076 1.77.231 2.643-.332.026-.666.039-.998.039zM52.2 34.268l-10.184 5.875-12.6-7.267a1.612 1.612 0 0 0-1.607 0l-9.086 5.241c-.77.443-1.496.95-2.172 1.521-2.608-3.715-2.863-8.609-.539-12.639a11.845 11.845 0 0 1 10.229-5.896c2.055 0 4.09.548 5.884 1.582L52.2 34.268zM41.98 12c6.505 0 11.795 5.287 11.795 11.788v7.7l-20.072-11.58a14.966 14.966 0 0 0-2.408-1.122C33.211 14.669 37.325 12 41.98 12zm26.003 15.003c3.25 5.629 1.314 12.851-4.319 16.101l-20.075 11.58V42.932l12.599-7.269c.498-.287.805-.817.805-1.391V23.788c0-.885-.08-1.767-.232-2.636a11.842 11.842 0 0 1 11.222 5.851z"
                ></path>
              </svg>
            </a> */}
          </p>
          <p className="flex flex-wrap gap-2 max-w-lg">
            {sponsors.map((handle, index) => {
              return handle === 'private sponsor' ? (
                <span
                  role="presentation"
                  title="Private sponsor"
                  className="inline-flex w-8 h-8 bg-gray-700 items-center justify-center text-gray-900"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.288 15.784H19.5711C19.5263 15.7168 19.5039 15.6271 19.4367 15.56C19.1455 15.1568 18.6752 14.8879 18.1599 14.8208C16.883 14.6864 15.3822 14.6864 14.1055 14.8208C13.5903 14.8656 13.1198 15.1567 12.8063 15.5823C12.7839 15.6047 12.7839 15.6272 12.7839 15.6272C12.2688 15.4479 11.7088 15.4479 11.1934 15.6272C11.1711 15.6048 11.1711 15.5823 11.1711 15.5823C10.8798 15.1567 10.4095 14.888 9.8719 14.8208C8.59502 14.6864 7.09426 14.6864 5.8175 14.8208C5.30234 14.8656 4.85438 15.1343 4.54062 15.56C4.49577 15.6271 4.45108 15.7168 4.40624 15.784H3.71204C3.46563 15.784 3.21924 15.9632 3.19688 16.232C3.17454 16.5232 3.39844 16.7696 3.68968 16.7696H4.24968C4.24968 16.8368 4.24968 16.9265 4.27202 16.9937L4.45124 17.8224C4.74249 19.256 5.99688 20.264 7.4528 20.2865H8.21436H8.23671C9.64795 20.2865 10.8798 19.3234 11.2383 17.957L11.4623 17.0611C11.4623 17.0162 11.4847 16.9939 11.4847 16.949C11.5295 16.7026 11.7311 16.5011 11.9998 16.5011H12.0447C12.3134 16.5011 12.5152 16.7027 12.5598 16.949C12.5598 16.9939 12.5822 17.0386 12.5822 17.0611L12.8062 17.957C13.1422 19.3458 14.3742 20.2865 15.8078 20.2865H15.8302H16.5917C18.0253 20.2642 19.3022 19.2337 19.5933 17.8224L19.7725 16.9937C19.7948 16.9265 19.7948 16.8368 19.7948 16.7696H20.3548C20.6461 16.7696 20.87 16.5232 20.8476 16.232C20.7808 15.9631 20.5344 15.784 20.288 15.784H20.288Z"
                      fill="currentColor"
                    />
                    <path
                      d="M17.8688 5.63677C17.4432 4.51677 16.256 3.88957 15.0912 4.15833L12.5152 4.74069C12.1568 4.83023 11.7984 4.83023 11.4401 4.74069L8.86416 4.15833C7.69932 3.88958 6.53464 4.51677 6.08652 5.63677L4.24964 10.3856H19.6832L17.8688 5.63677Z"
                      fill="currentColor"
                    />
                    <path
                      d="M22.4384 12.6927L20.512 11.3486H3.488L1.5616 12.6702C1.18082 12.9614 1.36004 13.544 1.83051 13.544H22.1697C22.64 13.544 22.8192 12.9615 22.4385 12.6927H22.4384Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              ) : (
                <a key={index} href={`https://github.com/${handle}`}>
                  <img
                    title={handle}
                    alt=""
                    src={`https://github.com/${handle}.png`}
                    className="w-8 rounded-sm"
                  />
                </a>
              )
            })}
          </p>
        </section>

        {/* <section className="flex justify-center">
          <a
            href="https://vercel.com?utm_source=ui-devtools&utm_campaign=oss"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="174"
              height="36"
              viewBox="0 0 212 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="212" height="44" rx="8" fill="black" />
              <path
                d="M60.4375 15.2266V26.5H61.8438V22.4766H64.6797C66.7969 22.4766 68.3047 20.9844 68.3047 18.875C68.3047 16.7266 66.8281 15.2266 64.6953 15.2266H60.4375ZM61.8438 16.4766H64.3281C65.9609 16.4766 66.8594 17.3281 66.8594 18.875C66.8594 20.3672 65.9297 21.2266 64.3281 21.2266H61.8438V16.4766ZM73.3441 26.6484C75.7425 26.6484 77.2269 24.9922 77.2269 22.2891C77.2269 19.5781 75.7425 17.9297 73.3441 17.9297C70.9456 17.9297 69.4613 19.5781 69.4613 22.2891C69.4613 24.9922 70.9456 26.6484 73.3441 26.6484ZM73.3441 25.4375C71.7503 25.4375 70.8519 24.2812 70.8519 22.2891C70.8519 20.2891 71.7503 19.1406 73.3441 19.1406C74.9378 19.1406 75.8363 20.2891 75.8363 22.2891C75.8363 24.2812 74.9378 25.4375 73.3441 25.4375ZM89.2975 18.0781H87.9459L86.2897 24.8125H86.1647L84.2819 18.0781H82.9928L81.11 24.8125H80.985L79.3288 18.0781H77.9694L80.3288 26.5H81.6881L83.5631 19.9844H83.6881L85.5709 26.5H86.9381L89.2975 18.0781ZM93.8213 19.1172C95.1572 19.1172 96.0478 20.1016 96.0791 21.5938H91.4384C91.54 20.1016 92.4775 19.1172 93.8213 19.1172ZM96.04 24.3203C95.6884 25.0625 94.9541 25.4609 93.8681 25.4609C92.4384 25.4609 91.5088 24.4062 91.4384 22.7422V22.6797H97.4931V22.1641C97.4931 19.5469 96.1103 17.9297 93.8369 17.9297C91.5244 17.9297 90.04 19.6484 90.04 22.2969C90.04 24.9609 91.5009 26.6484 93.8369 26.6484C95.6806 26.6484 96.9931 25.7578 97.3838 24.3203H96.04ZM99.2825 26.5H100.626V21.2812C100.626 20.0938 101.556 19.2344 102.837 19.2344C103.103 19.2344 103.587 19.2812 103.697 19.3125V17.9688C103.525 17.9453 103.243 17.9297 103.025 17.9297C101.908 17.9297 100.939 18.5078 100.689 19.3281H100.564V18.0781H99.2825V26.5ZM108.181 19.1172C109.517 19.1172 110.408 20.1016 110.439 21.5938H105.798C105.9 20.1016 106.838 19.1172 108.181 19.1172ZM110.4 24.3203C110.048 25.0625 109.314 25.4609 108.228 25.4609C106.798 25.4609 105.869 24.4062 105.798 22.7422V22.6797H111.853V22.1641C111.853 19.5469 110.47 17.9297 108.197 17.9297C105.884 17.9297 104.4 19.6484 104.4 22.2969C104.4 24.9609 105.861 26.6484 108.197 26.6484C110.041 26.6484 111.353 25.7578 111.744 24.3203H110.4ZM116.76 26.6484C117.924 26.6484 118.924 26.0938 119.455 25.1562H119.58V26.5H120.861V14.7344H119.518V19.4062H119.4C118.924 18.4844 117.932 17.9297 116.76 17.9297C114.619 17.9297 113.221 19.6484 113.221 22.2891C113.221 24.9375 114.603 26.6484 116.76 26.6484ZM117.072 19.1406C118.596 19.1406 119.549 20.3594 119.549 22.2891C119.549 24.2344 118.603 25.4375 117.072 25.4375C115.533 25.4375 114.611 24.2578 114.611 22.2891C114.611 20.3281 115.541 19.1406 117.072 19.1406ZM131.534 26.6484C133.667 26.6484 135.065 24.9219 135.065 22.2891C135.065 19.6406 133.674 17.9297 131.534 17.9297C130.378 17.9297 129.354 18.5 128.893 19.4062H128.768V14.7344H127.424V26.5H128.706V25.1562H128.831C129.362 26.0938 130.362 26.6484 131.534 26.6484ZM131.221 19.1406C132.76 19.1406 133.674 20.3203 133.674 22.2891C133.674 24.2578 132.76 25.4375 131.221 25.4375C129.69 25.4375 128.737 24.2344 128.737 22.2891C128.737 20.3438 129.69 19.1406 131.221 19.1406ZM137.261 29.5469C138.753 29.5469 139.425 28.9688 140.143 27.0156L143.433 18.0781H142.003L139.698 25.0078H139.573L137.261 18.0781H135.808L138.925 26.5078L138.768 27.0078C138.417 28.0234 137.995 28.3906 137.222 28.3906C137.034 28.3906 136.823 28.3828 136.659 28.3516V29.5C136.847 29.5312 137.081 29.5469 137.261 29.5469ZM154.652 26.5L158.55 15.2266H156.402L153.589 24.1484H153.457L150.621 15.2266H148.394L152.332 26.5H154.652ZM162.668 19.3203C163.832 19.3203 164.598 20.1328 164.637 21.3984H160.613C160.699 20.1484 161.512 19.3203 162.668 19.3203ZM164.652 24.1484C164.371 24.7812 163.707 25.1328 162.746 25.1328C161.473 25.1328 160.652 24.2422 160.605 22.8203V22.7188H166.574V22.0938C166.574 19.3984 165.113 17.7812 162.676 17.7812C160.199 17.7812 158.66 19.5078 158.66 22.2578C158.66 25.0078 160.176 26.6719 162.691 26.6719C164.707 26.6719 166.137 25.7031 166.488 24.1484H164.652ZM168.199 26.5H170.137V21.5625C170.137 20.3672 171.012 19.5859 172.27 19.5859C172.598 19.5859 173.113 19.6406 173.262 19.6953V17.8984C173.082 17.8438 172.738 17.8125 172.457 17.8125C171.356 17.8125 170.434 18.4375 170.199 19.2812H170.067V17.9531H168.199V26.5ZM181.7 20.8281C181.497 19.0312 180.168 17.7812 177.973 17.7812C175.403 17.7812 173.895 19.4297 173.895 22.2031C173.895 25.0156 175.411 26.6719 177.981 26.6719C180.145 26.6719 181.489 25.4688 181.7 23.6797H179.856C179.653 24.5703 178.981 25.0469 177.973 25.0469C176.653 25.0469 175.856 24 175.856 22.2031C175.856 20.4297 176.645 19.4062 177.973 19.4062C179.036 19.4062 179.676 20 179.856 20.8281H181.7ZM186.817 19.3203C187.981 19.3203 188.747 20.1328 188.786 21.3984H184.762C184.848 20.1484 185.661 19.3203 186.817 19.3203ZM188.802 24.1484C188.52 24.7812 187.856 25.1328 186.895 25.1328C185.622 25.1328 184.802 24.2422 184.755 22.8203V22.7188H190.723V22.0938C190.723 19.3984 189.262 17.7812 186.825 17.7812C184.348 17.7812 182.809 19.5078 182.809 22.2578C182.809 25.0078 184.325 26.6719 186.841 26.6719C188.856 26.6719 190.286 25.7031 190.637 24.1484H188.802ZM192.427 26.5H194.364V14.6484H192.427V26.5Z"
                fill="white"
              />
              <path d="M23.3248 13L32.6497 29H14L23.3248 13Z" fill="white" />
              <line
                x1="43.5"
                y1="2.18557e-08"
                x2="43.5"
                y2="44"
                stroke="#222"
              />
            </svg>
          </a>
        </section> */}
      </div>
    </div>
  )
}

export default App
